import React, { useState, useEffect } from 'react';

export default function Nav({ lang, setLang, t }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-200 ${scrolled ? 'border-b border-rule' : 'border-b border-transparent'}`}
      style={{
        background: scrolled ? 'rgba(244,247,251,0.85)' : 'transparent',
        backdropFilter: scrolled ? 'saturate(150%) blur(10px)' : 'none',
        WebkitBackdropFilter: scrolled ? 'saturate(150%) blur(10px)' : 'none',
      }}
    >
      <div className="max-w-content mx-auto flex items-center px-4 py-3 md:px-8 md:py-[18px]">
        <div className="flex items-center gap-3.5 md:gap-7">
          {['projects', 'skills', 'testimonials', 'about', 'contact'].map((k) => (
            <a
              key={k}
              href={`#${k}`}
              onClick={scrollTo(k)}
              className="text-[14px] md:text-[15px] font-medium text-ink-2 no-underline hover:text-ink transition-colors duration-150"
            >
              {t.nav[k]}
            </a>
          ))}
          <div className="inline-flex border border-rule rounded-full p-0.5 bg-surface">
            {['en', 'es'].map((l) => (
              <button
                key={l}
                onClick={() => setLang(l)}
                className={`font-mono text-[12px] tracking-[0.06em] uppercase font-medium px-2.5 py-1.5 rounded-full cursor-pointer border-0 transition-colors duration-150 ${
                  lang === l ? 'bg-ink text-bg' : 'bg-transparent text-ink-2'
                }`}
              >
                {l}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
